import { PureComponent } from 'react';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'components/Modal';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { noop } from 'lodash/fp';

import SwapVerticalIcon from 'components/icons/SwapVerticalIcon.com.svg';
import { InputBoxesField } from 'components/forms/InputBoxes';
import { SelectGroupField } from 'components/forms/Select';

import cn from './styles.local.less';

export default class SortControl extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChanged: PropTypes.func,
  };

  static defaultProps = {
    onChanged: noop,
  };

  state = {
    isShown: false,
  };

  handleChange = (e) => {
    const { onChanged } = this.props;

    onChanged(e);

    this.hide();
  };

  hide = () => {
    this.setState({
      isShown: false,
    });
  };

  show = () => {
    this.setState({
      isShown: true,
    });
  };

  render() {
    const { className, name, options } = this.props;

    return (
      <div className={cns(className, 'form-inline')}>
        <Button
          className={cns(cn.button, 'hidden-md hidden-lg btn-icon')}
          data-qa-selector="adasd"
          onClick={this.show}
        >
          <SwapVerticalIcon className={cn.icon} />
        </Button>

        <Modal bsSize="small" onHide={this.hide} show={this.state.isShown}>
          <Modal.Header closeButton>
            <Modal.Title>
              <SwapVerticalIcon className={cn.icon} />
              <span className={cn.modalTitle}>
                {__('search.filters.sort.label')}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={cn.optionsList}>
              <InputBoxesField
                type="radio"
                name={name}
                options={options}
                className={cn.radio}
                onChanged={this.handleChange}
              />
            </div>
          </Modal.Body>
        </Modal>

        <SelectGroupField
          className={cns(cn.sortWrapper, 'hidden-xs', 'hidden-sm')}
          label={__('search.filters.sort.label')}
          name={name}
          options={options}
          onChanged={this.handleChange}
        />
      </div>
    );
  }
}
